import { Product } from 'models'
import { useEffect, useState } from 'react'

export const useProductsContainerHeight = (scopeProductsCount: number): number => {
  const productLineHeight = 62
  const maxVisibleProducts = 15

  const [
    productsContainerHeight,
    setProductsContainerHeight
  ] = useState<number>(0)

  useEffect(() => {
    const maxVisibleProductLines = scopeProductsCount
      ? Math.max(Math.floor(Math.min(scopeProductsCount, maxVisibleProducts) / 3), 1)
      : 0
    setProductsContainerHeight(maxVisibleProductLines * productLineHeight + 10)
  }, [scopeProductsCount])

  return productsContainerHeight
}

export const useSearchFilter = (products: Product[]): {
  searchValue: string
  setSearchValue: (value: string) => void
  filteredProducts: Product[]
} => {
  const [searchValue, setSearchValue] = useState<string>('')

  const filteredProducts = products.filter(p => {
    return p.name.toLowerCase().includes(searchValue.trim().toLowerCase())
  })

  return {
    searchValue,
    setSearchValue,
    filteredProducts
  }
}
